import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import image1 from '../../assets/images/pages/article-5/1.jpg'
import image2 from '../../assets/images/pages/article-5/2.jpg'
import image3 from '../../assets/images/pages/article-5/3.jpg'
import dyachkin from '../../assets/images/pages/article-5/dyachkin.jpg'
import sivolapova from '../../assets/images/pages/article-5/sivolapova.jpg'
import { Articles } from '../../components/Article/Articles/Articles'
// import { CollectionBanner } from '../../components/Collection/CollectionBanner/CollectionBanner'
import { Feedback } from '../../components/Feedback/Feedback'
import { Footer } from '../../components/Footer/Footer'
import { Header } from '../../components/Header/Header'
import { BackButton } from '../../components/UI/BackButton/BackButton'
import styles from '../../pages/ArticlesPage/articlePage.module.scss'

export const ArticlePage5 = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      <Header />
      <main className={`${styles.articlePage} ${styles.article1}`}>
        <section className={styles.articleIntro}>
          <BackButton url='/' />

          <h1>
            <b>Одобрить за&nbsp;24&nbsp;часа:</b> <br />
            чем интересна ипотека через сайт застройщика
          </h1>

          <div className={styles.articleLead}>
            Ипотека начинается с&nbsp;выбора банка. К&nbsp;этой мысли принято
            относиться как к&nbsp;аксиоме&nbsp;&mdash; но&nbsp;что, если система
            может работать иначе? Компания ПИК внедрила необычное решение,
            позволяющее получить ипотеку на&nbsp;сайте девелопера. Разбираемся,
            как это работает и&nbsp;почему востребовано у&nbsp;покупателей
            квартир
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image1} alt={''} />
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Как работает ипотека от&nbsp;застройщика
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Ипотека заняла доминирующее положение при покупке жилья
                в&nbsp;стране. По&nbsp;данным компании ПИК, 80% сделок
                на&nbsp;первичном рынке закрывается с&nbsp;помощью ипотеки.
                Только в&nbsp;2022 году у&nbsp;девелопера купили в&nbsp;ипотеку
                почти 43&nbsp;тыс. квартир.&nbsp;70% ипотечных сделок заключили
                через сайт компании.
              </p>
              <p>
                Подача заявки через сайт застройщика заметно упрощает
                и&nbsp;ускоряет получение ипотеки. К&nbsp;примеру, на&nbsp;сайте
                ПИК пользователю достаточно выбрать квартиру и&nbsp;загрузить
                документы&nbsp;&mdash; обычно это паспорт и&nbsp;СНИЛС. Для
                отдельных программ требуется справка о&nbsp;подтверждении дохода
                и&nbsp;трудовая книжка, заверенная работодателем&nbsp;&mdash;
                но, согласно практике компании ПИК, в&nbsp;85% случаев без
                дополнительных документов можно обойтись.
              </p>
              <p>
                После этого ПИК сам отправляет заявку в&nbsp;несколько банков:
                полный перечень представлен на&nbsp;
                <a href={'https://www.pik.ru/mortgage'} target={'_blank'}>
                  сайте
                </a>{' '}
                застройщика. Весь процесс проходит удаленно и&nbsp;в&nbsp;одном
                месте, что значительно экономит время и&nbsp;усилия. Статус
                обращения пользователь сайта ПИК отслеживает в&nbsp;личном
                кабинете: обычно на&nbsp;получение ответа от&nbsp;банка уходит
                один-два дня. Это заметно быстрее, чем стандартные
                7-10&nbsp;дней, принятые во&nbsp;многих банках.
              </p>
              <p>
                &laquo;Для клиента это более удобная ситуация&nbsp;&mdash;
                сродни работе с&nbsp;ипотечными брокерами,&nbsp;&mdash; оценил
                эффективность системы генеральный директор
                &bdquo;INFOLine-Аналитика&ldquo; Михаил Бурмистров
                в&nbsp;разговоре с&nbsp;РБК. &mdash;&nbsp;В&nbsp;противном
                случае приходится потратить больше времени, чтобы выбрать
                то&nbsp;или иное ипотечное предложение&raquo;.
              </p>
              {/* <p>
                Важный фактор, стимулирующий такой спрос: господдержка. Согласно
                условиям программы, она продолжит действовать
                до&nbsp;1&nbsp;июня 2024&nbsp;года. А&nbsp;значит, остается еще
                много времени, чтобы воспользоваться льготными ставками.
              </p> */}
              <p>
                &laquo;В&nbsp;2020 году ПИК стал первым застройщиком,
                организовавшим ипотечную сделку и&nbsp;покупку квартиры
                полностью онлайн,&nbsp;&mdash; рассказал директор финансовых
                продуктов ПИК Алексей Трубников. &mdash;&nbsp;За&nbsp;три года
                наши клиенты получили больше 100&nbsp;тыс. ипотечных кредитов
                дистанционно через сайт компании. Механизм работает также, как
                при подаче через банк, но&nbsp;выбор становится шире, так как
                с&nbsp;помощью компании ПИК потенциальный заемщик может получить
                предложения сразу от&nbsp;нескольких банков&nbsp;&mdash;
                и&nbsp;выбрать наиболее подходящее для себя. Кредитная
                организация также проверяет доходы клиента, корректность данных
                в&nbsp;анкете, кредитную историю. Разница в&nbsp;том, что
                запустить этот волнительный для покупателя процесс можно
                из&nbsp;дома, в&nbsp;комфортной обстановке. Это быстро, удобно,
                не&nbsp;требует множества документов и&nbsp;времени&raquo;.
              </p>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <div className={styles.articleDescrImg}>
            <img src={image2} alt={''} />
          </div>

          <h2 className={styles.articleContentTitle}>
            Почему повышается процент одобрений
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Ключевое отличие ипотеки с&nbsp;заявкой через сайт застройщика
                от&nbsp;прямого обращением в&nbsp;конкретный банк&nbsp;&mdash;
                высокий процент одобрений. По&nbsp;статистике ПИК,
                около&nbsp;98% заявок, отправленных через сайт, получают
                положительный результат. Такой эффект достигается за&nbsp;счет
                того, что заявка уходит сразу в&nbsp;несколько банков. Если одна
                кредитная организация откажет в&nbsp;ипотеке, заявка отправится
                в&nbsp;следующий банк. Чем больше банков, тем выше вероятность
                получить кредит. Никаких дополнительных усилий со&nbsp;стороны
                заемщика здесь не&nbsp;требуется: процесс последовательного
                перебора банков автоматизирован.
              </p>
              <p>
                Другую причину повышенного числа одобрений описала Анастасия
                Сиволапова, начальник управления по&nbsp;работе
                с&nbsp;партнерами &laquo;Абсолют Банка&raquo;. &laquo;Портрет
                клиента ПИК соответствует портрету клиента &bdquo;Абсолют
                Банка&ldquo; по&nbsp;уровню дохода, возрасту, семейному
                положению, долговой нагрузке и&nbsp;другим основным параметрам.
                Вероятно, по&nbsp;этой причине процент одобрения заявок,
                поступающих от&nbsp;компании ПИК, выше, чем в&nbsp;среднем
                по&nbsp;банку&raquo;,&nbsp;&mdash; пояснила Сиволапова
                в&nbsp;беседе с&nbsp;РБК.
              </p>
              <p>
                Согласно данным ВТБ, процент одобрения заявок, направленных
                через сайт застройщика, превышает долю их&nbsp;согласования
                через банк в&nbsp;среднем на&nbsp;10%. &laquo;Зачастую при
                обращении к&nbsp;застройщику клиент уже понимает все свои
                потребности для приобретения конкретной недвижимости, знает
                условия программ и&nbsp;понимает свои
                возможности&raquo;,&nbsp;&mdash; рассказал РБК Евгений Дячкин,
                вице-президент, руководитель департамента продаж
                в&nbsp;партнерских каналах ВТБ.
              </p>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Как банки реагирует на&nbsp;множественность заявок
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Заявка на&nbsp;ипотеку сразу в&nbsp;несколько банков ожидаемо
                принесет больше ответов, однако не&nbsp;каждый покупатель
                решается ее&nbsp;отправить. Причина: опасение, что банки
                посчитают потенциального заемщика и&nbsp;его настойчивость
                в&nbsp;получении средств подозрительным. Опрос банков показал,
                что эти опасения справедливы только в&nbsp;редких
                случаях&nbsp;&mdash; крупнейшие банки, лидирующие по&nbsp;объему
                выдачи ипотечных кредитов, никак не&nbsp;это учитывают. Вот что
                говорят об&nbsp;этом сами представители банков:
              </p>
            </div>
          </div>
        </section>

        <section
          className={styles.articleProduct}
          style={{ background: '#e4f0d5' }}
        >
          <div
            className={styles.articleProductContainer}
            style={{ marginBottom: 0 }}
          >
            <div className={`${styles.articleSpeaker} ${styles.articleWidth}`}>
              <img src={dyachkin} alt='Евгений Дячкин' />
              <div className={styles.articleProductText}>
                <span className={styles.articleProductName}>
                  Евгений Дячкин,
                </span>{' '}
                вице-президент, руководитель департамента продаж
                в&nbsp;партнерских каналах ВТБ:
              </div>
            </div>
            <div
              className={`${styles.articleProductText} ${styles.articleWidth}`}
            >
              <p>
                &mdash;&nbsp;Нередко клиент, желая приобрести недвижимость,
                обращается сразу в&nbsp;несколько банков. Это стандартная
                практика, которая не&nbsp;влияет на&nbsp;решение
                по&nbsp;одобрению. Клиент может купить несколько квартир
                с&nbsp;использованием ипотеки ВТБ, если ему позволяет его
                уровень дохода; более того, само такое поведение клиентов, когда
                клиент хочет получить несколько решений от&nbsp;разных банков,
                является нормой для многих цифровых каналов.
              </p>
            </div>
          </div>
        </section>

        <section
          className={styles.articleProduct}
          style={{ background: '#e3d3f7' }}
        >
          <div className={styles.articleProductContainer}>
            <div className={`${styles.articleSpeaker} ${styles.articleWidth}`}>
              <img src={sivolapova} alt='Анастасия Сиволапова' />
              <div className={styles.articleProductText}>
                <span className={styles.articleProductName}>
                  Анастасия Сиволапова,
                </span>{' '}
                начальник управления по&nbsp;работе с&nbsp;партнерами
                &laquo;Абсолют Банка&raquo;:
              </div>
            </div>
            <div
              className={`${styles.articleProductText} ${styles.articleWidth}`}
            >
              <p>
                &mdash;&nbsp;Если клиент подает одновременно 3-4 заявки
                в&nbsp;разные банки на&nbsp;ипотеку, это считается нормой.
                Заемщик сравнивает условия, выбирает лучшее для себя
                предложения. 6-8 заявок&nbsp;&mdash; это уже очень большое
                количество обращений, которое может повлиять на&nbsp;скоринговый
                балл клиента. Поводом для отказа такое количество запросов
                в&nbsp;банки не&nbsp;будет, но&nbsp;тем не&nbsp;менее, может
                оказать влияние на&nbsp;итоговое решение ввиду действующих
                алгоритмов оценки.
                <br />
                <br />
              </p>
              <p>
                По&nbsp;данным компании ПИК, в&nbsp;реальной практике девелопер
                отправляет не&nbsp;более четырех заявок в&nbsp;разные банки:
                в&nbsp;подавляющем большинстве случаев этого достаточно для
                получения положительного решения. Только в&nbsp;случае, если
                потенциальному заемщику откажут сразу четыре банка, заявка
                пойдет дальше, разъяснили в&nbsp;ПИКе.
              </p>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            За&nbsp;счет чего растет скорость получения
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                По&nbsp;данным ПИК, в&nbsp;среднем заявки на&nbsp;ипотеку через
                сайт компании получают одобрение в&nbsp;течение 24&nbsp;часов.
                Покупатель недвижимости не&nbsp;оказывается в&nbsp;подвешенном
                состоянии надолго, получая решение в&nbsp;ближайшие сутки.
              </p>
              <p>
                Важно, что время рассмотрения заявки никак не&nbsp;зависит
                от&nbsp;способа подачи заявления&nbsp;&mdash; на&nbsp;сайте
                девелопера или в&nbsp;банке. Как объясняет Анастасия Сиволапова,
                время рассмотрения заявки обуславливается не&nbsp;только
                финансовым положением заемщика, сферой его занятости
                и&nbsp;формой подтверждения дохода, но&nbsp;и&nbsp;корректным
                заполнением. На&nbsp;сайте ПИК форма подачи заявки оформлена
                просто и&nbsp;интуитивно понятно, поэтому пользователи обычно
                правильно заполняют ее&nbsp;с&nbsp;первой попытки.
              </p>
              <p>
                &laquo;Срок рассмотрения заявки обычно не&nbsp;зависит
                от&nbsp;способа подачи, так как все заявки проходят через единый
                кредитный конвейер банка. Но&nbsp;если брать средний показатель,
                то&nbsp;заявки, поступающие от&nbsp;застройщика через его сайт,
                рассматриваются быстрее, так как имеют меньше отклонений
                от&nbsp;стандартных условий и&nbsp;обычно не&nbsp;требуют
                дополнительного анализа. Время рассмотрения составляет
                от&nbsp;10&nbsp;минут&raquo;,&nbsp;&mdash; рассказали
                в&nbsp;&laquo;Абсолют Банке&raquo;.
              </p>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <div className={styles.articleDescrImg}>
            <img src={image3} alt={''} />
          </div>

          <h2 className={styles.articleContentTitle}>
            Что важно знать о&nbsp;субсидированной ставке
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Многие не&nbsp;решаются отправить заявку на&nbsp;льготную
                ипотеку непривычным способом из-за страха лишиться выгодных
                условий. Однако оформленная через сайт застройщика ипотека
                не&nbsp;отменяет действующие акции банков и&nbsp;поддержку
                государства. &laquo;Заявка на&nbsp;ипотеку оформляется
                на&nbsp;сайте застройщика на&nbsp;тех&nbsp;же условиях, которые
                доступны при обращении в&nbsp;офисы ВТБ, включая бонусы
                и&nbsp;льготные условия кредитования&raquo;,&nbsp;&mdash;
                подчеркнул Евгений Дячкин.
              </p>
              <p>
                Заемщик также может получить дополнительные возможности
                наподобие субсидированной ставки. При подаче заявки
                на&nbsp;ипотеку по&nbsp;госпрограмме через застройщика можно
                оформить кредит на&nbsp;сумму до&nbsp;30&nbsp;млн
                руб.&nbsp;в&nbsp;Москве, Московской области, Санкт-Петербурге,
                Ленинградской области и&nbsp;до&nbsp;15&nbsp;млн
                руб.&nbsp;в&nbsp;остальных регионах. Без субсидированной ставки
                сумма покупки ограничена 12&nbsp;млн руб.&nbsp;и&nbsp;6&nbsp;млн
                руб. соответственно.
              </p>
              <p>
                Если покупатель выбирает на&nbsp;сайте девелопера отдельный
                продукт под названием &laquo;ПИК Ипотека&raquo;,
                то&nbsp;к&nbsp;программе с&nbsp;господдержкой, семейной ипотеке
                или ипотеке для ИТ-специалистов прибавится бонус в&nbsp;виде
                сниженной ставки, скидки на&nbsp;квартиру и&nbsp;дисконта
                на&nbsp;страховку в&nbsp;размере до&nbsp;40%. Дополнительная
                выгода при покупке с&nbsp;помощью &laquo;ПИК Ипотеки&raquo;
                достигает 0,5%, подсчитали в&nbsp;компании.
              </p>
            </div>
          </div>
        </section>

        {/* <div style={{ background: '#e4f0d5' }}>
          <section className={styles.articleContent}>
            <div className={styles.articleCollectionBanner}>
              <CollectionBanner
                title={'Квартиры в готовых проектах'}
                lead={'Дома с инфраструктурой для жизни'}
                img={investmentImg}
                id={1}
                color={'#e4f0d5'}
                currentPage={'5'}
              />
            </div>
          </section>
        </div> */}

        <section className={styles.articleContent}>
          <Articles excludeId='5' />
        </section>
        <Feedback />
      </main>
      <Footer />
    </>
  )
}
